// src/components/dashboard/vendor/TrainerUtilizationList.js
// Ranked list of this vendor's trainers by session load (trailing 30 days /
// next 60 days), so the vendor admin can spot over/under-loaded trainers.
import React from 'react';
import { Table } from 'react-bootstrap';
import DashboardCard from '../DashboardCard';

function TrainerUtilizationList({ data, loading }) {
  return (
    <DashboardCard
      title="Trainer Utilization"
      icon="bi-person-workspace"
      loading={loading}
      isEmpty={!loading && data.length === 0}
      emptyMessage="No trainers linked to this vendor yet."
    >
      <Table borderless size="sm" className="mb-0 align-middle">
        <tbody>
          {data.map(trainer => (
            <tr key={trainer.trainerId}>
              <td className="fw-semibold">{trainer.trainerName}</td>
              <td className="text-end text-muted">{trainer.sessionCount} session{trainer.sessionCount === 1 ? '' : 's'}</td>
            </tr>
          ))}
        </tbody>
      </Table>
    </DashboardCard>
  );
}

export default TrainerUtilizationList;
